import { getDependentModelsFromInclude } from "./getDependentModelsFromInclude";
import {
  ObjectPoolModelToStateGraphConfig,
  PosQueryIncludeFragment,
  UsePosCollectionParams,
} from "./queries";

// NB: At the time of writing, this was unused? Possible we can get rid of this.
export function getDependentModels<
  TModelName extends keyof ObjectPoolModelToStateGraphConfig,
  TIncludes extends PosQueryIncludeFragment<TModelName>,
>(objectName: TModelName, params: UsePosCollectionParams<TModelName, TIncludes>) {
  const dependentModels: Set<keyof ObjectPoolModelToStateGraphConfig> =
    getDependentModelsFromInclude(objectName, params);
  dependentModels.add(objectName);
  return dependentModels;
}
